import ParameterFieldBase, { IParameterFieldBaseOptions } from './ParameterFieldBase';
import { ReplaceNullValuesField as EditComponent } from '../tsx/ReplaceNullValuesField';

interface IReplaceNullValuesFieldOptions extends IParameterFieldBaseOptions {
    type?: string;
}

export class ReplaceNullValuesField extends ParameterFieldBase<IReplaceNullValuesFieldOptions> {
    public static defaultValidators = [];

    public static EditComponent = EditComponent;

    public getDefaultOptions() {
        return {
            type: 'numeric'
            //type: EditComponent.valueTypes.numeric
        };
    }

    constructor(glob, title: string, validators?: any, defaultVal?: any, options?) {
        super(glob, title, ReplaceNullValuesField.defaultValidators, validators, defaultVal, options);
    }
}
